import { dealAtom, dealErrorAtom } from '@/states/deal.state';
import { useAtomValue } from 'jotai';

export const useLatestPreviousCampaigns = () => {
  const deal = useAtomValue(dealAtom);
  const error = useAtomValue(dealErrorAtom);

  return {
    previousCampaigns: deal?.latestPreviousCampaigns ?? [],
    loading: deal === null && !error,
    error,
  };
};
